import type { ResourcesConfig } from 'aws-amplify';

export const awsCognitoConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.PUBLIC_PSIM_USERPOOL_ID || '',
      userPoolClientId: process.env.PUBLIC_USERPOOL_WEB_CLIENT_ID || '',
      identityPoolId: process.env.PUBLIC_PSIM_IDENTITYPOOL_ID || '',
      loginWith: {
        oauth: {
          domain: process.env.PUBLIC_COGNITO_HOSTED_UI_DOMAIN || '',
          scopes: [
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin',
          ],
          redirectSignIn: [process.env.PUBLIC_URL || ''],
          redirectSignOut: [process.env.PUBLIC_URL || ''],
          responseType: 'code',
        },
      },
    },
  },
};
